var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.$router.go(-1)}}},[_vm._v("← Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }